import React, { useContext, useEffect, useState } from 'react';
import { Card, CardBody, CardHeader, Col, Container, Form, FormFeedback, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { getUserByEmail, getUserById } from '../../Users/services/userApi';
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import HistoryContext from '../../../Components/Hooks/HistoryContext';
import { useQuery } from 'react-query';
import MyInfo from '../components/MyInfo';
import ProfileImage from '../components/ProfileImage';

const MyProfile = () => {
    const history = useContext(HistoryContext);
    useEffect(() => {
        document.title = `Mon Profil | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;
    }, []);

    const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
    const userEmail = currentUser?.email
    
    const { isLoading, isError, error, data: user } = useQuery(
        ["user", userEmail], 
        ()=> getUserByEmail(userEmail),
        {
            enabled : !!userEmail
        }
    );
    
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb page="Mon Profil" history={history} />
                    <Row>
                        <Col lg ={1}></Col>
                        <Col lg ={4} >
                            <Card className='mb-3'>
                                <br/>
                                <h6 className='text-mutued text-center'>Ma photo de profile</h6>
                                <ProfileImage user = {user} size={150}/>
                                <div className='mb-3'>
                                    <h5 className="fs-17 mb-1 text-center">{user?.name || "-"}</h5>
                                    <p className="text-muted mb-0 text-center">Role {user?.role?.name || "-"}</p>
                                </div>
                            </Card>
                        </Col>
                        <Col lg ={6}>
                            <MyInfo user = {user} isLoading={isLoading} isError = {isError} error={error}/>
                        </Col>
                        <Col lg ={1}></Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default MyProfile;